<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params, close }">
      <CodDetails v-if="visible" :row="params.row" :close="close"></CodDetails>
    </template>
  </cTable>
</template>

<script>
import {
  getCodBill,
  add,
  getCountryCurrency,
  codReStatistics,
  getListDetails,
  update,
  batchWriteOff,
  codConfirmBill,
  delCod,
  addCnbNo,
  cancelAgentOff,
  getAnalyze,
  getBatchRate,
  saveBatchRate,
  cancelConfirm,
} from "@/api/finance/codList";
import { getAgent } from "@/api/tracker/agent";
import { getCurrency } from "@/api/finance/currency";
import { getSearchConfig } from "@/api/finance/cod";
import { getBank } from "@/api/finance/bank";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import CodDetails from "./details";

export default {
  name: "codList",
  components: {
    cTable,
    CodDetails,
  },
  data() {
    return {
      methods: {
        list: (p) => {
          p.status = "RECEIVE";
          return getCodBill(p);
        },
        getListDetails,
        // del,
        add,
        update,
        getSearchConfig,
        codConfirmBill,
        delCod,
        addCnbNo,
        getCurrency,
        batchWriteOff,
        getCountryCurrency,
        getBatchRate,
        codReStatistics,
        getBank,
        cancelAgentOff,
        getAnalyze,
        saveBatchRate,
        cancelConfirm,
        beforeModalList({ data }) {
          return data;
        },
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10,
              },
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
              total_real_amount: [
                {
                  required: true,
                  message: "Please Enter total_real_amount",
                  type: "number",
                  trigger: "blur",
                },
              ],
              total_fee: [
                {
                  required: true,
                  message: "Please Enter total_fee",
                  type: "number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { total_fee: 24 },
            { total_real_amount: 24 },
            { name: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("total_fee"),
              key: "total_fee",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("total_fee"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("amount_receivable"),
              key: "total_real_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("name"),
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 2,
                type: "textarea",
              },
            },
            // {
            //   name: this.$t("Remarks"),
            //   key: "remarks",
            //   component: "Input",
            //   placeholder: () => this.$t("enter") + this.$t("Remarks")
            // },
            // {
            //   name: this.$t("type"),
            //   key: "types",
            //   component: "Radio",
            //   options: [
            //     { label: "总部", value: 1 },
            //     { label: "分公司", value: 2 },
            //     { label: "部门", value: 3 },
            //     { label: "岗位", value: 4 }
            //   ],
            //   bind: {
            //     border: true
            //   }
            // }
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.$refs["form"].handleFilterData({
                ids: this.$page.selectAll.map((item) => item.id),
                bank_id: row.bank_id,
                types: "RECEIVE",
              });
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transaction_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { bank: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transaction_id: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("bank"),
              key: "bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "account_type",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
                click({ obj, formData }) {
                  // console.log(obj);
                  // console.log(formData);
                  formData.bank_id = obj.id;
                },
              },
            },
            {
              name: this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        rate: {
          methods: {
            ok({ list, close, row }) {
              let data = {
                country: list,
                id: this.params.id,
              };
              if (this.type == "rate") data.id = row.id;
              else data.token = row.token;
              this.$page
                .handleRequestMethods(
                  this.type == "rate" ? "codReStatistics" : "saveBatchRate",
                  data,
                  false,
                  true
                )
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 1100,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("countryName"),
                key: "title",
              },
              {
                name: () => this.$t("countryCode"),
                key: "code",
                width: 80,
              },
              {
                name: () => this.$t("currencyCode"),
                key: "currency",
                width: 80,
              },
              {
                name: () => this.$t("rate") + "(To USD)",
                key: "rate",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
              },
              {
                name: () => this.$t("rate") + "(To AED)",
                key: "cod_agent_to_aed_rate",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
              },
              {
                name: () => this.$t("rate") + "(To SAR)",
                key: "cod_agent_to_sar_rate",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
              },
              {
                name: () => this.$t("rate") + "(AED To USD)",
                key: "aed_to_usd",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
                methods: {
                  "on-change"({ row }) {
                    this.list.map((item) => (item.aed_to_usd = row.aed_to_usd));
                  },
                },
              },
              {
                name: () => this.$t("rate") + "(SAR To USD)",
                key: "sar_to_usd",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
                methods: {
                  "on-change"({ row }) {
                    this.list.map((item) => (item.sar_to_usd = row.sar_to_usd));
                  },
                },
              },
            ],
          },
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
          },
          footer: { show: () => false },
        },
        analyze: {
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                  style: {
                    margin: "0 5px",
                  },
                },
              },
            ],
            methods: {
              export() {
                let data = JSON.parse(JSON.stringify(this.data));
                data.export = 1;
                this.$page
                  .handleRequestMethods("getAnalyze", data)
                  .then((res) => {
                    this.$Message[res.status ? "success" : "error"]({
                      background: true,
                      content: res.msg,
                      duration: res.status ? 2 : 5,
                    });
                    if (res.status) {
                      window.open(this.$globalUrl + res.payload);
                    }
                  });
              },
            },
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            title: this.$t("statistics"),
            listFn: "getAnalyze",
          },
          table: {
            config: {
              height: 600,
              showFooter: true,
              footerCellClassName: "col-red",
              footerMethod: ({ columns, data }) => {
                const sums = [];
                columns.forEach((column) => {
                  let sumCell = null;
                  switch (column.property) {
                    case "seq":
                      sumCell = this.$t("total");
                      break;
                    case "name":
                      sumCell = "-";
                      break;
                    case "currency":
                      sumCell = "-";
                      break;
                    case "total_votes":
                      sumCell = sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2
                      );
                      break;
                    default:
                      sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2,
                        "format"
                      );
                  }
                  sums.push(sumCell);
                });
                // 返回一个二维数组的表尾合计
                return [sums];
              },
            },

            fields: [
              {
                name: () => this.$t("alipay_name"),
                key: "name",
                minWidth: 130,
              },
              {
                name: () => this.$t("currencyCode"),
                minWidth: 80,
                key: "currency",
                align: "left",
              },
              {
                name: () => this.$t("Votes"),
                key: "total_votes",
                minWidth: 80,
                align: "left",
              },
              {
                name: () => this.$t("Total_original_currency"),
                key: "origin_amount",
                minWidth: 130,
                align: "left",
              },
              {
                name: () => this.$t("USD"),
                children: [
                  {
                    name: () => this.$t("total_amount"),
                    key: "amount_usd",
                    minWidth: 130,
                    align: "left",
                  },
                  {
                    name: () => this.$t("HandlingFee"),
                    key: "handling_fee_usd",
                    minWidth: 130,
                    align: "left",
                  },
                  {
                    name: () =>
                      this.$t("receivable") + "/" + this.$t("refundAmount"),
                    key: "confirm_fee_usd",
                    minWidth: 130,
                    align: "left",
                  },
                ],
              },
            ],
          },
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },

          {
            key: "client_agent_id",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            component: "Select",
            options: [],
            config: { label: "agent_name", value: "id" },
          },
          {
            key: "bill_status",
            placeholder() {
              return this.$t("select") + this.$t("bill_type");
            },
            component: "Select",
            options: [],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("confirm"),
              type: "confirm",
              fnName: "confirm",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-checkmark",
                type: "error",
              },
            },
            {
              name: () => this.$t("batch") + this.$t("rate"),
              type: "batchRate",
              fnName: "batchRate",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error",
              },
              id: 367,
            },
            {
              name: () => this.$tz("取消确认"),
              type: "cancel",
              fnName: "cancel",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            cancel() {
              this.$Modal.confirm({
                title: this.$tz("取消确认"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "cancelConfirm",
                    { ids: this.selectAll.map((t) => t.id) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            batchRate() {
              let data = {
                billIds: this.selectAll.map((item) => item.id),
              };
              this.handleRequestMethods("getBatchRate", data).then((res) => {
                let data = res.payload.data.map((item) => {
                  item.rate = item.currency.rate_to_usd;
                  item.cod_agent_to_aed_rate =
                    item.currency.cod_agent_to_aed_rate;
                  item.cod_agent_to_sar_rate =
                    item.currency.cod_agent_to_sar_rate;
                  item.aed_to_usd = item.currency.aed_to_usd;
                  item.sar_to_usd = item.currency.sar_to_usd;
                  item.currency = item.currency.code;
                  item.country = item.code;
                  return item;
                });
                this.getModal("rate").open(
                  { token: res.payload.token },
                  function () {
                    this.setTitle(this.$t("batch") + this.$t("rate"));
                    this.type = "batchRate";
                    this.list = data;
                  }
                );
                // this.$Message["success"]({
                //   background: true,
                //   content: res.msg
                // });
                // this.getList();
              });
            },
            export() {
              this.exportExc();
            },
            confirm() {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("bill1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("codConfirmBill", {
                    ids: data,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            writeOff() {
              let data = {
                check_amount_currency: "USD",
                check_amount: parseFloat(
                  this.selectAll
                    .map((item) => parseFloat(item["total_real_amount"]))
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                ),
              };
              this.getModal("writeOff").open(data, function () {
                this.type = "batchWriteOff";
                this.setTitle(this.$t("writeOff"));
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",

          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("check_bill_number"),
          key: "check_bill_number",
          component: this.$hasPermission(322) ? "Button" : "span",
          minWidth: 140,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ h, row }) {
              return row.check_bill_number;
            },
            click({ row }) {
              if (!this.$hasPermission(322)) return;
              this.$page
                .getModal("showDetails")
                .setTitle(row.check_bill_number);
              // this.getModal("writeOff").type = "writeOff";
              this.$page.getModal("showDetails").open({ row });
            },
          },
        },
        {
          name: () => this.$t("agentName"),
          align: "left",
          key: "client_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("codNAme"),
          key: "name",
          align: "left",
          minWidth: 150,
        },
        {
          name: () => this.$t("total_votes"),
          key: "total_votes",
          align: "left",
          width: 80,
        },
        {
          name: () => this.$t("total_amount") + "(USD)",
          key: "total_amount",
          align: "left",
          width: 110,
        },
        {
          name: () => this.$t("total_fee") + "(USD)",
          key: "total_fee",
          align: "left",
          width: 120,
        },
        {
          name: () => this.$t("amount_receivable") + "(USD)",
          align: "left",
          key: "total_real_amount",
          width: 120,
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          width: 80,
        },
        {
          name: () => this.$t("finances") + this.$t("order_desc"),
          align: "left",
          key: "remarks",
          width: 100,
        },
        {
          name: () => this.$t("operate"),
          align: "left",
          key: "operator_name",
          width: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170,
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          width: 170,
        },
        {
          name: () => this.$t("bank"),
          align: "left",
          key: "bank",
          width: 100,
        },
        {
          name: () => this.$t("check_amount"),
          key: "check_amount",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("transaction_id"),
          key: "transaction_id",
          align: "left",
          minWidth: 110,
        },
        {
          name: () => this.$t("check_amount_currency"),
          key: "check_amount_currency",
          align: "left",
          minWidth: 100,
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 400,
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "add",
              fnName: "add",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status == 9 || row.status == 4 ? true : false;
              },
              id: 365,
            },
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status == 9 || row.status == 4 ? true : false;
              },
              id: 366,
            },
            {
              name: this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status == 9 || row.status == 4 ? true : false;
              },
              id: 356,
            },
            {
              name: () => this.$t("cancel") + this.$t("writeOff"),
              type: "noWriteOff",
              fnName: "noWriteOff",
              bind: {
                type: "info",
              },
              disabled({ row }) {
                return row.status != 9 || row.status == 4 ? true : false;
              },
              id: 470,
            },
            {
              name: () => this.$t("statistics"),
              type: "analyze",
              fnName: "analyze",
              bind: {
                type: "error",
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.status == 9 || row.status == 4 ? true : false;
              },
              id: 368,
            },
          ],
          methods: {
            analyze({ row }) {
              this.getModal("analyze").open({}, function () {
                this.data = { id: row.id };
                this.$page
                  .handleRequestMethods("getAnalyze", this.data)
                  .then((res) => {
                    this.list = res.payload;
                  });
                this.setTitle(
                  row.check_bill_number + "(" + this.$t("statistics") + ")"
                );
              });
            },
            add({ row }) {
              // this.handleRequestMethods("getDetails", row.id).then(res => {
              this.getModal("add").setTitle(this.$t("addTo"));
              this.getModal("add").type = "addCnbNo";
              this.getModal("add").open({ id: row.id });
              // });
            },
            update({ row }) {
              this.handleRequestMethods("getListDetails", row.id).then(
                (res) => {
                  this.getModal("update").setTitle(this.$t("update"));
                  this.getModal("update").type = "update";
                  this.getModal("update").open(res.payload);
                }
              );
            },

            rate({ row }) {
              this.handleRequestMethods("getCountryCurrency", {
                id: row.id,
              }).then((res) => {
                let data = res.payload.map((item) => {
                  item.country = item.code;
                  item.cod_agent_to_sar_rate =
                    item.currency.cod_agent_to_sar_rate;
                  item.cod_agent_to_aed_rate =
                    item.currency.cod_agent_to_aed_rate;
                  item.aed_to_usd = item.currency.aed_to_usd;
                  item.sar_to_usd = item.currency.sar_to_usd;
                  item.rate = item.currency.rate_to_usd;
                  item.currency = item.currency.code;
                  return item;
                });
                this.getModal("rate").setTitle(this.$t("rate"));
                this.getModal("rate").open({ id: row.id }, function () {
                  this.type = "rate";
                  this.list = data;
                });
              });
            },
            // writeOff({ row }) {
            //   this.handleRequestMethods("getListDetails", row.id).then(res => {
            //     this.getModal("writeOff").setTitle(this.$t("writeOff"));
            //     this.getModal("writeOff").type = "writeOff";
            //     this.getModal("writeOff").open(res.payload);
            //   });
            // },
            noWriteOff({ row }) {
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("writeOff"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelAgentOff", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("delCod", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  activated() {
    if (this.$store.state.user.pageUrl) {
      this.$refs["table"].$refs["header"].searchForm.keywords =
        this.$store.state.user.pageUrl;
      this.$store.state.user.pageUrl = "";
      this.$refs["table"].getList();
    }
  },
  async created() {
    let data = (await getSearchConfig()).data.payload;
    let agentData = (await getAgent()).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "time_type") {
        item.options = Object.keys(data.time_type).map((item) => ({
          value: item,
          label: data.time_type[item],
        }));
        this.$refs["table"].$refs["header"].searchForm["time_type"] =
          item.options[0].value;
      }
      if (item.key === "bill_status")
        item.options = Object.keys(data.receive_bill).map((item) => ({
          value: item,
          label: data.receive_bill[item],
        }));
      if (item.key === "client_agent_id") item.options = agentData;
    });
  },
};
</script>
